import { useState, useEffect } from "react";
import { ENCRYPTED_KEY, GET_AVERAGE_INDIVIDUAL_STUDENT_ANALYTIC, fetchData } from "../../components/Service";
import { Link, useParams } from "react-router-dom";
import Canvas from "./Component/Canvas";
import { ItemBox } from "./Component/Component";
import { decodedText, encodedText } from "../../components/CommonMethod";

const IndividualStudentReview = () => {
    window.document.title = "Individual Student Review";
    const [data, setData] = useState(null);
    const [query, setQuery] = useState('');
    const params = useParams()
    const [paramsData, setParamsData] = useState(null);
    const [bgcolors] = useState(['#6ce5e8', '#ff66c4', '#ff4e7b', '#d84c39', '#ed9a4c']);

    useEffect(() => {
        try {
            setParamsData(JSON.parse(decodedText(params.query, ENCRYPTED_KEY)));
        } catch (error) {
            window.history.go(-1);
        }
    }, [params])

    useEffect(() => {
        if (paramsData && query) {
            fetchData(`${GET_AVERAGE_INDIVIDUAL_STUDENT_ANALYTIC}?${query}&student_id=${paramsData.student_id}`, 'GET', '', true, false, (res) => {
                if (res && res.records) {
                    setData(res.records);
                }
            })
        }
    }, [query, paramsData])

    return (
        <>
            <style>
                {`
                table, th, td {
                    border:3px solid black;
                    padding: 15px 5px;
                  }
                `}
            </style>

            <div className="container-fluid">
                <div className="page-head sticky_top_padding">
                    <div className="row gy-2">
                        <div className="col-sm-6">
                            {data && <>
                                <div className="h3 text-dim">
                                    <span className="fw-normal">
                                        <Link to={`/cms/class-review/${encodedText({ query: query }, ENCRYPTED_KEY)}`} className="text-decoration-none">Class Review </Link>
                                        <i className="fa fa-angle-double-right"></i> <Link to={`/cms/student-review/${encodedText({ class_id: data.student.student_section.id, query: query }, ENCRYPTED_KEY)}`} className="text-decoration-none">{`${data.student.student_section.section_name} (${data.student.student_group.group_code})`} </Link>
                                    </span>
                                    <i className="fa fa-angle-double-right"></i> <span className="">{`${data.student.first_name} ${data.student.last_name}`}</span>
                                </div>
                            </>}
                        </div>
                        <div className="col-sm-6 mb-2 text-end">
                            <button className="btn btn-lg border" type="button" style={{whiteSpace:'nowrap'}} data-bs-toggle="offcanvas" data-bs-target="#offcanvasExample" aria-controls="offcanvasExample">
                                <svg className="icon me-2"><use href="#icon_filter"></use></svg> Filter
                            </button>
                        </div>
                    </div>
                </div>

                <div className="row px-0 mx-2 pt-4 justify-content-center text-center" id="box-container">
                    <ItemBox title={"Average Mark"} data={data?.student_marks} bgcolor={bgcolors[2]} />
                    <ItemBox title={"Workbook Completion Rate"} data={data?.completion_rate} bgcolor={bgcolors[1]} />
                    <ItemBox title={"Average Completion Time"} data={data?.average_completion_time} bgcolor={bgcolors[3]} time />
                    <ItemBox title={"Average Confidence Score"} data={data?.confidence_score} bgcolor={bgcolors[4]} />
                </div>
                <div className="row mt-4 pt-4">
                    <div className="col-md-12">
                        <div className="table-responsive">
                            <table className="text-center w-100">
                                <tr>
                                    <th style={{ minWidth:'200px'}}>Module</th>
                                    <th style={{ minWidth:'200px'}}>Average Mark</th>
                                    <th style={{ minWidth:'200px'}}>Average Completion Time</th>
                                    <th style={{ minWidth:'200px'}}>Average Completion Rate</th>
                                    <th style={{ minWidth:'200px'}}>Average Confidence Score</th>
                                </tr>
                                {data?.module_data?.length > 0 ? data?.module_data?.map((item, key) => {
                                    return <tr key={key}>
                                        <td><Link to={`/cms/workbook-review/${encodedText({ student_id: data.student.id, module_id: item.module_id, query: query }, ENCRYPTED_KEY)}`} className="">{item.module_name} ({item.course_course_abbr})</Link></td>
                                        <td>{item.average_marks ?? 0}%</td>
                                        <td>{item.average_completion_time ?? 0}</td>
                                        <td>{item.completion_rate ?? 0}%</td>
                                        <td>{item.average_confidence_score ?? 0}%</td>
                                    </tr>
                                }) : <tr><td colSpan={5}>No Record found.</td></tr>}
                            </table>
                        </div>
                    </div>
                </div>
            </div>
            <Canvas setQuery={setQuery} />
        </>
    )
}
export default IndividualStudentReview;